import { CreditDepositInput } from "model/TipCredit";
import { API_ADMIN_ROOT } from "services/baseURLs.config";
import firebase from "services/firebase/firebase.config";

const getToken = async () => {
  return await firebase.auth().currentUser?.getIdToken();
};

const getCompanyCreditDeposits = async (
  page = 0,
  pageSize = 20,
  companyId?: number,
  status?: string
) => {
  const token = await getToken();
  const query = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
    companyId: String(companyId),
    ...(status ? { status } : {}),
  }).toString();

  const res = await fetch(
    `${API_ADMIN_ROOT}/companies/credits/deposits?${query}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

  if (!res.ok) throw new Error(res.statusText);
  const json = await res.json();

  return json;
};

const addCompanyCreditDeposit = async (
  deposit: CreditDepositInput
) => {
  const token = await getToken();
  const body = JSON.stringify(deposit);

  const res = await fetch(`${API_ADMIN_ROOT}/companies/credits/deposits`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body,
  });

  if (!res.ok) throw new Error(res.statusText);
};

const updateCompanyCreditDepositStatus = async (
  depositId: number,
  companyId: number,
  status: string
) => {
  const token = await getToken();
  const body = JSON.stringify({ depositId, companyId, status });

  const res = await fetch(
    `${API_ADMIN_ROOT}/companies/credits/deposits/${depositId}`,
    {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body,
    }
  );

  if (!res.ok) throw new Error(res.statusText);
  return await res.json();
};

const deleteCompanyCreditDeposit = async (depositId: number) => {
  const token = await getToken();
  const res = await fetch(
    `${API_ADMIN_ROOT}/companies/credits/deposits/${depositId}`,
    {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!res.ok) throw new Error(res.statusText);
  return true;
};

const getCompanyCreditWithdrawals = async (
  page = 0,
  pageSize = 20,
  companyId?: number,
  status?: string
) => {
  const token = await getToken();
  const query = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
    ...(companyId && { companyId: String(companyId) }),
    ...(status && { status }),
  }).toString();

  const res = await fetch(
    `${API_ADMIN_ROOT}/companies/credits/withdrawals?${query}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

  if (!res.ok) throw new Error(res.statusText);
  return await res.json();
};

const addCompanyCreditWithdrawal = async (
  companyId: number,
  amount: number,
  withdrawalByUserId: number,
  reference: string,
  sourceType: string,
  sourceId: number
) => {
  const token = await getToken();
  const body = JSON.stringify({
    companyId,
    amount,
    withdrawalByUserId,
    reference,
    sourceType,
    sourceId,
  });
  const res = await fetch(`${API_ADMIN_ROOT}/companies/credits/withdrawals`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body,
  });

  if (!res.ok) throw new Error(res.statusText);
  return await res.json();
};

const updateCompanyCreditWithdrawalStatus = async (
  withdrawalId: number,
  companyId: number,
  status: string
) => {
  const token = await getToken();
  const body = JSON.stringify({ withdrawalId, companyId, status });

  const res = await fetch(
    `${API_ADMIN_ROOT}/companies/credits/withdrawals/${withdrawalId}`,
    {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body,
    }
  );

  if (!res.ok) throw new Error(res.statusText);
  return await res.json();
};

const tipService = {
  getCompanyCreditDeposits,
  addCompanyCreditDeposit,
  updateCompanyCreditDepositStatus,
  deleteCompanyCreditDeposit,
  getCompanyCreditWithdrawals,
  addCompanyCreditWithdrawal,
  updateCompanyCreditWithdrawalStatus,
};

export default tipService;
